<template>
<el-dialog :show-close="false" top="4vh" :visible="true" width="80%" title="请填写本次红冲开票的通知单编号">
<div class="detail">
  <span>发票张数：{{dataSource.length}}张</span>
  <!-- <div>
    <span>未税金额总计：{{dataSource.length}}</span>
    <span>税额总计：{{dataSource.length}}</span>
    <span>价税合计总计：{{dataSource.length}}</span>
  </div> -->
</div>
<div class="list">
  <div v-for="(item, index) in data" :key="index">
    <!-- 标题部分 -->
    <el-row style="margin-top: 12px" type="flex" justify="center" align="middle">
      <el-col :span="2">
        <span>张次</span>
      </el-col>
      <el-col :span="2">
        <span>拆分发票ID</span>
      </el-col>
      <el-col :span="2">
        <span>规格型号</span>
      </el-col>
      <el-col :span="2">
        <span>单位</span>
      </el-col>
      <el-col :span="2">
        <span>数量</span>
      </el-col>
      <el-col :span="2">
        <span>开票名称</span>
      </el-col>
      <el-col :span="2">
        <span>未税金额</span>
      </el-col>
      <el-col :span="2">
        <span>税率</span>
      </el-col>
      <el-col :span="2">
        <span>税额</span>
      </el-col>
      <el-col :span="2">
        <span>价税合计</span>
      </el-col>
      <el-col :span="2">
        <span>发票号码</span>
      </el-col>
      <el-col :span="2">
        <span>发票代码</span>
      </el-col>
      <el-col :span="2">
        <span>开票日期</span>
      </el-col>
    </el-row>
    <!-- 数据 -->
    <el-row style="margin-top: 6px" type="flex" justify="center" align="middle" v-for="(subItem, idx) in item.ticket_json" :key="idx">
      <el-col :span="2">
        <span>{{item.order_no}}</span>
      </el-col>
      <el-col :span="2">
        <span>{{item.id}}</span>
      </el-col>
      <el-col :span="2">
        <span>{{subItem.spec}}</span>
      </el-col>
      <el-col :span="2">
        <span>{{subItem.unit}}</span>
      </el-col>
      <el-col :span="2">
        <span>{{subItem.quantity}}</span>
      </el-col>
      <el-col :span="2">
        <span>{{ subItem.invoice_name_json.full_name }}</span>
      </el-col>
      <el-col :span="2">
        <span>{{subItem.no_tax_amount}}</span>
      </el-col>
      <el-col :span="2">
        <span>{{subItem.tax_rate}}</span>
      </el-col>
      <el-col :span="2">
        <span>{{subItem.tax_amount}}</span>
      </el-col>
      <el-col :span="2">
        <span>{{subItem.with_tax_amount}}</span>
      </el-col>
      <el-col :span="2">
        <span>{{ item.invoice_json.fphm }}</span>
      </el-col>
      <el-col :span="2">
        <span>{{ item.invoice_json.fpdm }}</span>
      </el-col>
      <el-col :span="2">
        <span>{{ item.invoice_json.invoice_date }}</span>
      </el-col>
    </el-row>
    <div style="display: flex; flex-direction: row; align-items: center;">
      <span>通知单编号</span>
      <el-input v-model="item.notice_number" placeholder="请填写通知单编号" style="width: 40%" size="small"></el-input>
    </div>
  </div>
</div>
<div class="actions">
  <el-button @click="onCancel">取消</el-button>
  <el-button type="primary" @click="onSave">确定</el-button>
</div>
</el-dialog>
</template>

<script>

export default {
  props: {
    dataSource: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {
      data: []
    }
  },
  watch: {
    dataSource: {
      immediate: true,
      handler (newValue, oldValue) {
        this.data = newValue.map(item => {
          return item
        })
      }
    }
  },
  methods: {
    onCancel () {
      this.$emit('onClose')
    },
    getForm () {
      this.data.forEach((item, index) => {
        if (!item.notice_number) {
          throw Error(`张次${index + 1}未填写通知单编号`)
        }
      })
      return JSON.parse(JSON.stringify(this.data))
    },
    onSave () {
      try {
        this.$emit('onSave', this.getForm())
      } catch (error) {
        this.$message.error(error.message)
      }
    },
  }
}
</script>

<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
.detail {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  margin-bottom: 12px;
}
.list {
  height: 54vh;
  border: 12px solid #dcdfe6;
  padding: 12px;
  overflow: scroll;
}
.actions {
  margin-top: 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/invoice-apply/components/ticket-split/InvoiceSplitRedVoid.vue